import { render, staticRenderFns } from "./index_live_apply.vue?vue&type=template&id=6fb71554&scoped=true"
import script from "./index_live_apply.vue?vue&type=script&lang=js"
export * from "./index_live_apply.vue?vue&type=script&lang=js"
import style0 from "./index_live_apply.vue?vue&type=style&index=0&id=6fb71554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb71554",
  null
  
)

export default component.exports